"use client";

import { useState, useEffect, useMemo } from "react";
import { getBusinessProfile, type FleetBusinessProfile } from "@fm/api";
import type { ApiClient } from "@fm/api/types";
import { getApiBaseUrl } from "../lib/config";

export function useBusinessProfile(apiKey: string, apiBaseUrl?: string) {
  const [profile, setProfile] = useState<FleetBusinessProfile | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const apiClient = useMemo<ApiClient>(
    () => ({
      apiKey,
      baseUrl: getApiBaseUrl(apiBaseUrl),
    }),
    [apiKey, apiBaseUrl],
  );

  useEffect(() => {
    if (!apiKey) {
      setIsLoading(false);
      return;
    }

    const load = async () => {
      try {
        const result = await getBusinessProfile(apiClient);
        if (result) {
          setProfile(result);
        }
      } catch (error) {
        console.error("Failed to load business profile:", error);
      } finally {
        setIsLoading(false);
      }
    };

    load();
  }, [apiKey, apiClient]);

  return {
    profile,
    primaryColor: profile?.primary_color || null,
    isLoading,
  };
}
